/* ── 입체 버튼 시스템 ──
   물리 버튼처럼 보이도록 4개 층을 쌓는다:
     1) 위쪽 안쪽 하이라이트 — 광원이 위에서 온다는 신호
     2) 아래쪽 안쪽 그림자   — 표면의 두께
     3) 아래 단색 엣지(0 Npx 0) — 버튼의 옆면. 입체감의 핵심
     4) 바깥 확산 그림자     — 배경에서 떠 있는 느낌
   누르면 3)이 사라지고 버튼이 그만큼 내려가 실제로 눌리는 느낌이 난다.
   (누름 효과는 global.js의 .btn3d:active가 처리 — 터치에서도 동작) */

const join = (arr) => arr.filter(Boolean).join(", ");

export function btn3d(variant = "primary", dm = false) {
  const V = {
    /* 주 동작 — 인디고 그라데이션 */
    primary: {
      background: dm
        ? "linear-gradient(180deg,#8A92FF 0%,#6E71F2 52%,#5A5CE2 100%)"
        : "linear-gradient(180deg,#7A7DF7 0%,#6366F1 52%,#5356E4 100%)",
      color: "#FFFFFF",
      border: `2px solid ${dm ? "#4A4DCE" : "#4043CF"}`,
      rest: [
        "inset 0 1px 0 rgba(255,255,255,0.42)",
        "inset 0 -2px 3px rgba(45,42,120,0.30)",
        `0 3px 0 ${dm ? "#3E3FAD" : "#4338CA"}`,
        "0 8px 18px rgba(79,70,229,0.34)",
      ],
      active: [
        "inset 0 1px 0 rgba(255,255,255,0.28)",
        "inset 0 -1px 2px rgba(45,42,120,0.32)",
        "0 3px 9px rgba(79,70,229,0.28)",
      ],
    },

    /* 보조 동작 — 테두리형 */
    outline: {
      background: dm
        ? "linear-gradient(180deg,rgba(129,140,248,0.18),rgba(129,140,248,0.07))"
        : "linear-gradient(180deg,#FFFFFF,#EFF1FE)",
      color: dm ? "#A5B4FC" : "#4338CA",
      border: `2px solid ${dm ? "rgba(129,140,248,0.55)" : "rgba(99,102,241,0.42)"}`,
      rest: [
        dm ? "inset 0 1px 0 rgba(255,255,255,0.12)" : "inset 0 1px 0 rgba(255,255,255,0.95)",
        `0 3px 0 ${dm ? "rgba(99,102,241,0.30)" : "rgba(99,102,241,0.20)"}`,
        `0 6px 14px ${dm ? "rgba(0,0,0,0.30)" : "rgba(15,23,42,0.09)"}`,
      ],
      active: [
        dm ? "inset 0 1px 0 rgba(255,255,255,0.08)" : "inset 0 1px 0 rgba(255,255,255,0.7)",
        `0 2px 7px ${dm ? "rgba(0,0,0,0.28)" : "rgba(15,23,42,0.10)"}`,
      ],
    },

    /* 흰 배경 카드형 (Google 로그인 등) */
    white: {
      background: dm
        ? "linear-gradient(180deg,#273449,#1E293B)"
        : "linear-gradient(180deg,#FFFFFF,#F5F6F8)",
      color: dm ? "#F1F5F9" : "#0F172A",
      border: `2px solid ${dm ? "rgba(255,255,255,0.30)" : "rgba(15,23,42,0.22)"}`,
      rest: [
        dm ? "inset 0 1px 0 rgba(255,255,255,0.10)" : "inset 0 1px 0 rgba(255,255,255,1)",
        `0 3px 0 ${dm ? "rgba(0,0,0,0.45)" : "rgba(15,23,42,0.13)"}`,
        `0 8px 18px ${dm ? "rgba(0,0,0,0.38)" : "rgba(15,23,42,0.12)"}`,
      ],
      active: [
        dm ? "inset 0 1px 0 rgba(255,255,255,0.06)" : "inset 0 1px 0 rgba(255,255,255,0.8)",
        `0 3px 9px ${dm ? "rgba(0,0,0,0.35)" : "rgba(15,23,42,0.12)"}`,
      ],
    },

    /* 공유·복사 등 보조 강조 — 틸 */
    teal: {
      background: dm
        ? "linear-gradient(180deg,rgba(45,212,191,0.20),rgba(45,212,191,0.09))"
        : "linear-gradient(180deg,#F0FDFA,#DDF5F0)",
      color: dm ? "#5EEAD4" : "#0F766E",
      border: `2px solid ${dm ? "rgba(45,212,191,0.5)" : "rgba(20,184,166,0.42)"}`,
      rest: [
        dm ? "inset 0 1px 0 rgba(255,255,255,0.10)" : "inset 0 1px 0 rgba(255,255,255,0.95)",
        `0 3px 0 ${dm ? "rgba(20,184,166,0.32)" : "rgba(20,184,166,0.24)"}`,
        `0 6px 14px ${dm ? "rgba(0,0,0,0.28)" : "rgba(13,148,136,0.14)"}`,
      ],
      active: [
        dm ? "inset 0 1px 0 rgba(255,255,255,0.06)" : "inset 0 1px 0 rgba(255,255,255,0.7)",
        `0 2px 7px ${dm ? "rgba(0,0,0,0.26)" : "rgba(13,148,136,0.16)"}`,
      ],
    },

    /* 저장 완료 등 — 그린 */
    success: {
      background: "linear-gradient(180deg,#5FB36F 0%,#4A9A5A 52%,#3E874C 100%)",
      color: "#FFFFFF",
      border: "2px solid #35753F",
      rest: [
        "inset 0 1px 0 rgba(255,255,255,0.38)",
        "inset 0 -2px 3px rgba(20,70,35,0.30)",
        "0 3px 0 #2F6B3A",
        "0 8px 18px rgba(58,127,72,0.32)",
      ],
      active: [
        "inset 0 1px 0 rgba(255,255,255,0.25)",
        "0 3px 9px rgba(58,127,72,0.26)",
      ],
    },

    /* 삭제 등 — 레드 */
    danger: {
      background: dm
        ? "linear-gradient(180deg,rgba(255,90,80,0.16),rgba(255,90,80,0.07))"
        : "linear-gradient(180deg,#FFF5F4,#FFE6E3)",
      color: dm ? "#FF8F80" : "#C0392B",
      border: `2px solid ${dm ? "rgba(255,110,95,0.45)" : "rgba(200,60,45,0.32)"}`,
      rest: [
        dm ? "inset 0 1px 0 rgba(255,255,255,0.08)" : "inset 0 1px 0 rgba(255,255,255,0.9)",
        `0 3px 0 ${dm ? "rgba(200,60,45,0.32)" : "rgba(200,60,45,0.20)"}`,
        `0 6px 14px ${dm ? "rgba(0,0,0,0.28)" : "rgba(192,57,43,0.14)"}`,
      ],
      active: [
        dm ? "inset 0 1px 0 rgba(255,255,255,0.05)" : "inset 0 1px 0 rgba(255,255,255,0.7)",
        `0 2px 7px ${dm ? "rgba(0,0,0,0.26)" : "rgba(192,57,43,0.16)"}`,
      ],
    },
  };

  const v = V[variant] || V.primary;

  return {
    background: v.background,
    color: v.color,
    border: v.border,
    boxShadow: join(v.rest),
    // .btn3d:active가 읽어가는 누름 상태 그림자
    "--btn3d-active": join(v.active),
  };
}
